// Dictionnaire néerlandais (clé = texte français exact utilisé dans l'interface)
export const nl = {
  // ---- Header / navigation ----
  "Accueil": "Home",
  "Comment ça fonctionne": "Hoe het werkt",
  "Professionnels": "Vakmensen",
  "À propos": "Over ons",
  "Blog": "Blog",
  "Contact": "Contact",
  "Connexion": "Aanmelden",
  "Mon espace": "Mijn ruimte",
  "Décrire mon projet": "Beschrijf mijn project",
  "Ouvrir le menu": "Menu openen",
  "Fermer le menu": "Menu sluiten",
  "Déconnexion": "Afmelden",
  "Navigation principale": "Hoofdnavigatie",
  "Navigation mobile": "Mobiele navigatie",

  // ---- Métiers ----
  "Chauffage": "Verwarming",
  "Plomberie": "Loodgieterij",
  "Sanitaire": "Sanitair",
  "HVAC": "HVAC",
  "Climatisation": "Airconditioning",
  "Ventilation": "Ventilatie",
  "Pompe à chaleur": "Warmtepomp",
  "Électricité": "Elektriciteit",
  "Traitement de l'eau": "Waterbehandeling",

  // ---- Hero ----
  "La plateforme des techniques spéciales du bâtiment": "Het platform voor de speciale technieken in de bouw",
  "Techniques spéciales": "Speciale technieken",
  "du": "in de",
  "bâtiment.": "bouw.",
  "Décrivez votre projet et trouvez le professionnel adapté à vos besoins, partout en Belgique.": "Beschrijf uw project en vind de geschikte vakman voor uw noden, overal in België.",
  "Devenir partenaire pro": "Word professionele partner",
  "Gratuit": "Gratis",
  "Sans engagement": "Vrijblijvend",
  "Professionnels vérifiés": "Geverifieerde vakmensen",
  "De confiance": "Betrouwbaar",
  "Réponse rapide": "Snelle reactie",
  "Dans votre région": "In uw regio",
  "Installation de chaudière": "Installatie van ketels",
  "Confort thermique": "Thermisch comfort",
  "Air sain et performant": "Gezonde en efficiënte lucht",

  // ---- Comment ça fonctionne ----
  "Simple et efficace": "Eenvoudig en efficiënt",
  "Comment ça fonctionne ?": "Hoe werkt het?",
  "Devisto vous accompagne à chaque étape de votre projet.": "Devisto begeleidt u bij elke stap van uw project.",
  "En savoir plus": "Meer weten",
  "Décrivez votre projet": "Beschrijf uw project",
  "Expliquez votre besoin en quelques minutes. Ajoutez des photos, précisez votre localisation et vos attentes.": "Leg uw behoefte in enkele minuten uit. Voeg foto's toe, geef uw locatie en uw verwachtingen door.",
  "Devisto identifie les professionnels adaptés": "Devisto selecteert de geschikte vakmensen",
  "Les professionnels qualifiés de votre région, correspondant à votre projet, reçoivent votre demande.": "De gekwalificeerde vakmensen uit uw regio die bij uw project passen, ontvangen uw aanvraag.",
  "Échangez et avancez sur votre projet": "Overleg en ga verder met uw project",
  "Comparez les profils, échangez avec les professionnels et choisissez la meilleure solution pour votre projet.": "Vergelijk de profielen, bespreek met de vakmensen en kies de beste oplossing voor uw project.",

  // ---- Section audiences ----
  "Devisto": "Devisto",
  "La plateforme des techniques spéciales du bâtiment.": "Het platform voor de speciale technieken in de bouw.",
  "Devisto met en relation particuliers, professionnels et entreprises avec des spécialistes qualifiés des techniques du bâtiment, partout en Belgique.": "Devisto brengt particulieren, vakmensen en bedrijven in contact met gekwalificeerde specialisten in bouwtechnieken, overal in België.",
  "Particuliers": "Particulieren",
  "Trouvez le bon professionnel pour votre projet.": "Vind de juiste vakman voor uw project.",
  "Décrivez vos travaux ou votre besoin technique : nous le transmettons au professionnel qualifié de votre région.": "Beschrijf uw werken of uw technische behoefte: wij geven ze door aan de gekwalificeerde vakman uit uw regio.",
  "Recevez de nouvelles demandes et développez votre activité.": "Ontvang nieuwe aanvragen en laat uw activiteit groeien.",
  "Chauffage, plomberie, climatisation, électricité : recevez des demandes ciblées selon vos métiers et votre zone.": "Verwarming, loodgieterij, airconditioning, elektriciteit: ontvang gerichte aanvragen volgens uw vakgebieden en uw zone.",
  "Entreprises (B2B)": "Bedrijven (B2B)",
  "Trouvez des partenaires et sous-traitants pour vos chantiers.": "Vind partners en onderaannemers voor uw werf.",
  "Publiez vos missions de sous-traitance et recevez des candidatures de techniciens qualifiés et vérifiés.": "Publiceer uw onderaannemingsopdrachten en ontvang kandidaturen van gekwalificeerde en geverifieerde technici.",
  "Publier une mission": "Publiceer een opdracht",

  // ---- Services ----
  "Tous les métiers du CVC": "Alle technische vakgebieden",
  "Trouver un chauffagiste, un plombier, un électricien ou un spécialiste HVAC": "Vind een verwarmingsinstallateur, een loodgieter, een elektricien of een HVAC-specialist",
  "Quel que soit votre projet, Devisto transmet votre demande au professionnel qualifié adapté à votre besoin et à votre région, dans l'ensemble des métiers techniques de l'habitation.": "Wat uw project ook is, Devisto geeft uw aanvraag door aan de gekwalificeerde vakman die past bij uw behoefte en uw regio, voor alle technische vakgebieden van de woning.",
  "Installation, entretien et dépannage par un professionnel chauffage qualifié : chaudière, radiateurs, chauffage central.": "Installatie, onderhoud en herstelling door een gekwalificeerde verwarmingsvakman: ketel, radiatoren, centrale verwarming.",
  "Trouver un plombier pour vos installations sanitaires, réparations de fuites et rénovations de salle de bain.": "Vind een loodgieter voor uw sanitaire installaties, lekherstellingen en badkamerrenovaties.",
  "Installation et rénovation sanitaire : salles de bain, douches, WC, robinetterie et équipements.": "Sanitaire installatie en renovatie: badkamers, douches, toiletten, kranen en uitrusting.",
  "Installation, dépannage, mise en conformité, tableaux électriques, bornes de recharge et domotique.": "Installatie, herstelling, conformiteit, elektrische borden, laadpalen en domotica.",
  "Un professionnel HVAC pour vos systèmes de chauffage, ventilation et conditionnement d'air, en résidentiel comme en tertiaire.": "Een HVAC-vakman voor uw verwarmings-, ventilatie- en airconditioningsystemen, zowel residentieel als tertiair.",
  "Pose et maintenance de climatiseurs et systèmes réversibles pour votre confort en toute saison.": "Plaatsing en onderhoud van airconditioners en omkeerbare systemen voor uw comfort in elk seizoen.",
  "VMC simple et double flux : une ventilation performante pour une qualité d'air intérieur optimale.": "Enkelvoudige en dubbele ventilatie: performante ventilatie voor een optimale binnenluchtkwaliteit.",
  "Installation et entretien de pompe à chaleur air/eau pour réduire durablement votre facture énergétique.": "Installatie en onderhoud van lucht/water-warmtepompen om uw energiefactuur duurzaam te verlagen.",

  // ---- Section professionnels ----
  "Trouvez le bon professionnel": "Vind de juiste vakman",
  "Les bons professionnels pour vos projets.": "De juiste vakmensen voor uw projecten.",
  "Trouvez facilement un professionnel qualifié pour vos travaux et besoins techniques, partout en Belgique.": "Vind eenvoudig een gekwalificeerde vakman voor uw werken en technische noden, overal in België.",
  "Tous": "Alle",
  "Partenaire de lancement": "Lanceringspartner",
  "Premier partenaire Devisto dans le domaine du chauffage": "Eerste Devisto-partner op het vlak van verwarming",
  "Nouveau sur Devisto": "Nieuw op Devisto",
  "avis": "beoordelingen",
  "ans d'expérience": "jaar ervaring",
  "Devisto Score": "Devisto-score",
  "Ce domaine rejoint bientôt la plateforme": "Dit vakgebied komt binnenkort naar het platform",
  "Devisto réunit progressivement des professionnels dans toutes les techniques spéciales du bâtiment. Publiez votre demande : nous la transmettons au professionnel qualifié adapté.": "Devisto brengt geleidelijk vakmensen samen in alle speciale technieken van de bouw. Publiceer uw aanvraag: wij geven ze door aan de geschikte gekwalificeerde vakman.",
  "Devisto commence avec JMX Énergie et s'ouvre progressivement à des professionnels vérifiés dans toutes les techniques spéciales du bâtiment : chauffage, plomberie, ventilation, climatisation, pompes à chaleur et traitement de l'eau.": "Devisto start met JMX Énergie en stelt zich geleidelijk open voor geverifieerde vakmensen in alle speciale technieken van de bouw: verwarming, loodgieterij, ventilatie, airconditioning, warmtepompen en waterbehandeling.",

  // ---- Section pro (carte navy) ----
  "Espace professionnels": "Ruimte voor vakmensen",
  "Développez votre activité avec Devisto.": "Laat uw activiteit groeien met Devisto.",
  "Recevez des demandes qualifiées, développez votre clientèle et gagnez en visibilité auprès de particuliers qui recherchent des professionnels comme vous.": "Ontvang gekwalificeerde aanvragen, breid uw klantenbestand uit en win aan zichtbaarheid bij particulieren die vakmensen zoals u zoeken.",
  "Recevez des demandes correspondant à vos spécialités": "Ontvang aanvragen die bij uw specialiteiten passen",
  "Présentez votre entreprise et vos réalisations": "Presenteer uw bedrijf en uw realisaties",
  "Développez votre clientèle dans votre région": "Breid uw klantenbestand uit in uw regio",
  "Construisez votre réputation grâce aux avis clients": "Bouw uw reputatie op dankzij klantbeoordelingen",
  "Gérez vos demandes depuis votre espace pro": "Beheer uw aanvragen vanuit uw pro-ruimte",
  "Simple, rapide et sans engagement": "Eenvoudig, snel en vrijblijvend",
  "Mes demandes": "Mijn aanvragen",
  "Demandes reçues": "Ontvangen aanvragen",
  "En cours": "Lopend",
  "Nouveau": "Nieuw",
  "Devis envoyé": "Offerte verzonden",

  // ---- Section entreprises ----
  "Espace entreprises": "Ruimte voor bedrijven",
  "Vous cherchez un technicien pour vos chantiers ?": "Zoekt u een technicus voor uw werven?",
  "Je cherche un technicien": "Ik zoek een technicus",

  // ---- Bandeau stats ----
  "Professionnels partenaires": "Partnervakmensen",
  "Projets publiés": "Gepubliceerde projecten",
  "Clients accompagnés": "Begeleide klanten",
  "Note moyenne des clients": "Gemiddelde klantscore",

  // ---- Contact ----
  "Une question ? Parlons-en.": "Een vraag? Laten we erover praten.",
  "Vous êtes un particulier avec un projet de chauffage, de plomberie, d'électricité ou de HVAC, ou un professionnel qui souhaite rejoindre la plateforme ? Écrivez-nous, nous répondons rapidement.": "Bent u een particulier met een verwarmings-, loodgieterij-, elektriciteits- of HVAC-project, of een vakman die zich bij het platform wil aansluiten? Schrijf ons, wij antwoorden snel.",
  "Nom": "Naam",
  "Email": "E-mail",
  "Sujet": "Onderwerp",
  "Message": "Bericht",
  "Votre nom": "Uw naam",
  "Ex. : Question sur une demande de devis": "Bv.: Vraag over een offerteaanvraag",
  "Votre message…": "Uw bericht…",
  "Envoyer le message": "Verstuur het bericht",
  "Envoi en cours…": "Verzenden…",
  "Message envoyé !": "Bericht verzonden!",
  "Nous revenons vers vous au plus vite.": "Wij nemen zo snel mogelijk contact met u op.",

  // ---- Footer ----
  "Pour les clients": "Voor klanten",
  "Pour les professionnels": "Voor vakmensen",
  "Trouver un chauffagiste": "Vind een verwarmingsinstallateur",
  "Trouver un plombier": "Vind een loodgieter",
  "Climatisation & ventilation": "Airconditioning & ventilatie",
  "Professionnel HVAC": "HVAC-vakman",
  "Missions chauffagiste": "Opdrachten verwarming",
  "Missions plombier & HVAC": "Opdrachten loodgieterij & HVAC",
  "Devisto est une plateforme développée et portée par": "Devisto is een platform ontwikkeld en gedragen door",
  "JMX Énergie est le premier professionnel partenaire de Devisto pour les demandes liées au chauffage, à la plomberie et aux installations techniques.": "JMX Énergie is de eerste professionele partner van Devisto voor aanvragen in verband met verwarming, loodgieterij en technische installaties.",
  "Belgique": "België",
  "Devisto vous aide à trouver une solution adaptée à vos projets de chauffage, plomberie, sanitaire, électricité, ventilation, climatisation et pompes à chaleur en Belgique.": "Devisto helpt u een oplossing op maat te vinden voor uw verwarmings-, loodgieterij-, sanitair-, elektriciteits-, ventilatie-, airconditioning- en warmtepompprojecten in België.",

  // ---- Bloc lancement JMX ----
  "Pour son lancement,": "Voor de lancering is",
  "est le premier professionnel partenaire de Devisto. Les demandes correspondant à ses domaines d'expertise sont actuellement prises en charge par JMX Énergie.": "de eerste professionele partner van Devisto. Aanvragen die bij zijn domeinen van expertise passen, worden momenteel door JMX Énergie behandeld.",
  "À mesure que Devisto se développe, d'autres professionnels qualifiés pourront rejoindre la plateforme afin de proposer aux particuliers un choix plus large de solutions et de compétences. Devisto commence avec JMX Énergie, avec l'ambition de construire progressivement un réseau de professionnels de confiance.": "Naarmate Devisto groeit, kunnen andere gekwalificeerde vakmensen het platform vervoegen om particulieren een ruimer aanbod van oplossingen en competenties te bieden. Devisto start met JMX Énergie, met de ambitie om geleidelijk een netwerk van betrouwbare vakmensen uit te bouwen.",

  // ---- Divers sections ----
  "Installation pompe à chaleur": "Installatie warmtepomp",
  "Remplacement chaudière gaz": "Vervanging gasketel",
  "Rénovation salle de bain": "Badkamerrenovatie",
  "Publiez une mission de sous-traitance — chauffage, plomberie, sanitaire, ventilation, climatisation, pompe à chaleur ou électricité — et trouvez des professionnels qualifiés, avec les bonnes certifications, au bon endroit.": "Publiceer een onderaannemingsopdracht — verwarming, loodgieterij, sanitair, ventilatie, airconditioning, warmtepomp of elektriciteit — en vind gekwalificeerde vakmensen, met de juiste certificaten, op de juiste plaats.",

  "Toute la Belgique": "Heel België",

  // ---- Pages auth / inscription ----
  "Espace membres": "Ledenruimte",
  "Espace clients": "Klantenruimte",
  "Clients et professionnels : accédez à votre espace Devisto.": "Klanten en vakmensen: log in op uw Devisto-ruimte.",
  "Mot de passe": "Wachtwoord",
  "Mot de passe oublié ?": "Wachtwoord vergeten?",
  "Mot de passe oublié": "Wachtwoord vergeten",
  "Se connecter": "Aanmelden",
  "Connexion…": "Aanmelden…",
  "Pas encore de compte ?": "Nog geen account?",
  "Créer un compte client": "Maak een klantenaccount",
  "Compte entreprise": "Bedrijfsaccount",
  "Créer un compte entreprise": "Maak een bedrijfsaccount",
  "Nom complet": "Volledige naam",
  "8 caractères minimum": "minimaal 8 tekens",
  "Créer mon compte": "Maak mijn account",
  "Créer mon compte entreprise": "Maak mijn bedrijfsaccount",
  "Création…": "Aanmaken…",
  "Déjà un compte ?": "Heeft u al een account?",
  "Suivez vos demandes et échangez avec les professionnels.": "Volg uw aanvragen en bespreek met de vakmensen.",
  "Entreprise": "Bedrijf",
  "Nom de votre entreprise": "Naam van uw bedrijf",
  "Nom du contact": "Naam van de contactpersoon",
  "Téléphone": "Telefoon",
  "TVA": "BTW",
  "(facultatif)": "(optioneel)",
  "Publiez des missions de sous-traitance et trouvez des techniciens qualifiés.": "Publiceer onderaannemingsopdrachten en vind gekwalificeerde technici.",
  "Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte mail (et vos spams).": "Als er een account met dit e-mailadres bestaat, is zojuist een herstellink verzonden. Controleer uw mailbox (en uw spam).",
  "Retour à la connexion": "Terug naar aanmelden",
  "Clients et professionnels : entrez votre email pour recevoir un lien vous permettant de choisir un nouveau mot de passe.": "Klanten en vakmensen: voer uw e-mailadres in om een link te ontvangen waarmee u een nieuw wachtwoord kunt kiezen.",
  "Recevoir le lien": "Ontvang de link",
  "Envoi…": "Verzenden…",
  "Nouveau mot de passe": "Nieuw wachtwoord",
  "Confirmer le mot de passe": "Bevestig het wachtwoord",
  "Retapez le mot de passe": "Typ het wachtwoord opnieuw",
  "Les mots de passe ne correspondent pas": "De wachtwoorden komen niet overeen",
  "Mettre à jour mon mot de passe": "Werk mijn wachtwoord bij",
  "Mise à jour…": "Bijwerken…",
  "Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.": "Uw wachtwoord is bijgewerkt. U kunt zich nu aanmelden.",
  "Inscription impossible. Réessayez.": "Registratie mislukt. Probeer opnieuw.",
  "Réinitialisation impossible. Faites une nouvelle demande.": "Herstel mislukt. Doe een nieuwe aanvraag.",
  "Connexion impossible. Réessayez.": "Aanmelden mislukt. Probeer opnieuw.",
  "Votre session a expiré après une longue inactivité. Reconnectez-vous pour reprendre là où vous étiez.": "Uw sessie is verlopen na lange inactiviteit. Meld u opnieuw aan om verder te gaan waar u gebleven was.",

  // ---- Publier une demande ----
  "Publier une demande": "Publiceer een aanvraag",
  "Décrivez votre problème en vos mots — l'assistant structure votre projet et choisit le bon métier automatiquement.": "Beschrijf uw probleem in uw eigen woorden — de assistent structureert uw project en kiest automatisch het juiste vakgebied.",
  "Ex. : Ma chaudière ne fonctionne plus et elle affiche une erreur…": "Bv.: Mijn ketel werkt niet meer en geeft een foutmelding…",
  "Analyser": "Analyseer",
  "Analyse…": "Analyseren…",
  "Projet structuré : catégorie, titre et description pré-remplis ci-dessous. Vérifiez et ajustez si besoin.": "Project gestructureerd: categorie, titel en beschrijving zijn hieronder vooraf ingevuld. Controleer en pas aan indien nodig.",
  "Votre projet": "Uw project",
  "Les détails": "De details",
  "Vos coordonnées": "Uw gegevens",
  "Quel type de travaux ?": "Welk type werken?",
  "Titre de votre demande": "Titel van uw aanvraag",
  "Ex. : Remplacement d'une chaudière gaz": "Bv.: Vervanging van een gasketel",
  "Description": "Beschrijving",
  "Décrivez votre besoin : état actuel, surface, équipements, contraintes…": "Beschrijf uw behoefte: huidige toestand, oppervlakte, apparatuur, beperkingen…",
  "Code postal": "Postcode",
  "Commune": "Gemeente",
  "Ex. : 1000": "Bv.: 1000",
  "Ex. : Bruxelles": "Bv.: Brussel",
  "Délai souhaité": "Gewenste termijn",
  "Sélectionnez…": "Selecteer…",
  "Urgent": "Dringend",
  "Sous 1 mois": "Binnen 1 maand",
  "Sous 3 mois": "Binnen 3 maanden",
  "Je me renseigne": "Ik verken de mogelijkheden",
  "Elles ne sont partagées qu'avec les professionnels qui répondent à votre demande.": "Ze worden alleen gedeeld met de vakmensen die op uw aanvraag reageren.",
  "particulier": "particulier",
  "entreprise": "bedrijf",
  "Publier ma demande": "Publiceer mijn aanvraag",
  "Votre demande est publiée !": "Uw aanvraag is gepubliceerd!",
  "Les professionnels qualifiés de votre secteur vont être alertés. Vous recevrez leurs réponses directement par email.": "De gekwalificeerde vakmensen uit uw regio worden verwittigd. U ontvangt hun antwoorden rechtstreeks per e-mail.",
  "Créer un compte pour suivre ma demande": "Maak een account om mijn aanvraag te volgen",
  "Une erreur est survenue. Réessayez ou écrivez-nous à info@devis-to.be.": "Er is een fout opgetreden. Probeer opnieuw of schrijf naar info@devis-to.be.",
  "L'assistant n'a pas pu analyser. Réessayez.": "De assistent kon niet analyseren. Probeer opnieuw.",

  // ---- Devenir partenaire pro ----
  "Votre inscription est bien reçue !": "Uw inschrijving is goed ontvangen!",
  "Votre numéro de TVA est enregistré. Vous serez parmi les premiers contactés par email lors de l'ouverture du réseau de professionnels partenaires Devisto.": "Uw btw-nummer is geregistreerd. U bent een van de eersten die per e-mail wordt gecontacteerd bij de opening van het Devisto-partnernetwerk.",
  "Accéder à mon espace pro": "Ga naar mijn pro-ruimte",
  "Devisto, plateforme développée par JMX Énergie, ouvrira prochainement son réseau à des professionnels partenaires. Inscrivez-vous dès maintenant pour être parmi les premiers contactés lors de l'ouverture.": "Devisto, een platform ontwikkeld door JMX Énergie, opent binnenkort zijn netwerk voor partnervakmensen. Schrijf nu in om een van de eersten te zijn die bij de opening worden gecontacteerd.",
  "Société": "Bedrijf",
  "Email professionnel": "Professioneel e-mailadres",
  "Mot de passe de votre espace pro": "Wachtwoord van uw pro-ruimte",
  "Numéro de TVA": "Btw-nummer",
  "Format attendu : BE suivi de 10 chiffres (ex. BE 0123.456.789)": "Verwacht formaat: BE gevolgd door 10 cijfers (bv. BE 0123.456.789)",
  "Vérification VIES en cours…": "VIES-controle bezig…",
  "Numéro vérifié auprès de VIES": "Nummer geverifieerd via VIES",
  "Ce numéro de TVA n'est pas reconnu par le service officiel VIES.": "Dit btw-nummer wordt niet erkend door de officiële VIES-dienst.",
  "Vérification VIES momentanément indisponible — réessayez en quittant le champ.": "VIES-controle tijdelijk onbeschikbaar — probeer opnieuw door het veld te verlaten.",
  "Zone géographique d'intervention": "Geografische werkzone",
  "Sélectionnez votre province…": "Selecteer uw provincie…",
  "Vos métiers": "Uw vakgebieden",

  // ---- Publier une mission (B2B) ----
  "Publiez une mission de sous-traitance : les professionnels qualifiés correspondant à vos critères sont alertés immédiatement.": "Publiceer een onderaannemingsopdracht: de gekwalificeerde vakmensen die aan uw criteria voldoen, worden onmiddellijk verwittigd.",
  "Métier": "Vakgebied",
  "Spécialité": "Specialiteit",
  "Ex. : entretien chaudière gaz": "Bv.: onderhoud gasketel",
  "Qualification obligatoire": "Verplichte kwalificatie",
  "Ex. : G1, G2, VCA, certification électrique…": "Bv.: G1, G2, VCA, elektriciteitscertificering…",
  "Description de la mission": "Beschrijving van de opdracht",
  "Décrivez les travaux, le matériel nécessaire, les contraintes…": "Beschrijf de werken, het benodigde materiaal, de beperkingen…",
  "Adresse du chantier": "Adres van de werf",
  "Rue et numéro": "Straat en nummer",
  "Date": "Datum",
  "Horaire": "Uurrooster",
  "Durée": "Duur",
  "Ex. : 1 journée": "Bv.: 1 dag",
  "Tarif proposé (€/jour)": "Voorgesteld tarief (€/dag)",
  "Techniciens": "Technici",
  "Urgence": "Dringendheid",
  "Très urgent": "Zeer dringend",
  "Publication…": "Publiceren…",
  "Publier la mission": "Publiceer de opdracht",
  "Mission": "Opdracht",
  "publiée !": "gepubliceerd!",
  "Les techniciens qualifiés correspondant à votre mission sont alertés. Suivez les candidatures dans votre espace entreprise.": "De gekwalificeerde technici die bij uw opdracht passen, worden verwittigd. Volg de kandidaturen in uw bedrijfsruimte.",
  "Voir mes missions": "Bekijk mijn opdrachten",

  // ---- À propos / Blog / divers ----
  "À propos": "Over ons",
  "Derrière Devisto": "Achter Devisto",
  "JMX Énergie est le premier professionnel partenaire de Devisto pour les demandes liées au chauffage, à la plomberie et aux installations techniques. Plombier chauffagiste basé à Woluwe-Saint-Étienne, JMX Énergie intervient dans toute la Belgique pour l'installation, l'entretien et le dépannage de vos équipements.": "JMX Énergie is de eerste professionele partner van Devisto voor aanvragen in verband met verwarming, loodgieterij en technische installaties. Als loodgieter-verwarmingsinstallateur gevestigd in Sint-Stevens-Woluwe, werkt JMX Énergie in heel België voor de installatie, het onderhoud en de herstelling van uw apparatuur.",
  "Devisto a été conçue comme un véritable service : vous décrivez votre projet ou votre problème, et votre demande est transmise au professionnel qualifié adapté à votre besoin. La plateforme est amenée à s'ouvrir progressivement à d'autres professionnels partenaires, sélectionnés et vérifiés (numéro de TVA contrôlé via le service officiel VIES).": "Devisto is ontworpen als een echte dienst: u beschrijft uw project of uw probleem, en uw aanvraag wordt doorgegeven aan de gekwalificeerde vakman die bij uw behoefte past. Het platform zal geleidelijk opengaan voor andere partnervakmensen, geselecteerd en geverifieerd (btw-nummer gecontroleerd via de officiële VIES-dienst).",
  "Site officiel": "Officiële website",
  "Contact Devisto": "Contact Devisto",
  "Publier une demande": "Publiceer een aanvraag",
  "Le blog Devisto": "De Devisto-blog",
  "Offre de lancement": "Lanceringsaanbod",
  "Les 10 premiers abonnés reçoivent une tablette Xiaomi Redmi Pad SE 8.7": "De eerste 10 abonnees krijgen een Xiaomi Redmi Pad SE 8.7-tablet",
  "Une tablette professionnelle, offerte pour travailler avec Devisto sur chantier comme au bureau : créer vos devis, gérer vos factures, suivre vos clients et vos interventions, où que vous soyez.": "Een professionele tablet, gratis om met Devisto te werken op de werf én op kantoor: offertes maken, facturen beheren, klanten en interventies opvolgen, waar u ook bent.",
  "tablettes restantes": "tablets beschikbaar",
  "attribuées": "toegekend",
  "Offre terminée": "Aanbod afgelopen",
  "Offre limitée aux 10 premiers abonnements Devisto Premium.": "Aanbod beperkt tot de eerste 10 Devisto Premium-abonnementen.",
  "Profiter de l'offre": "Van het aanbod genieten",
  "Conditions de l'offre": "Voorwaarden van het aanbod",
  "Conditions de l'offre tablette": "Voorwaarden van het tabletaanbod",
  "Facturation Peppol, TVA 6 %, marge de chantier, organisation du travail : nos guides pour les artisans et entrepreneurs du bâtiment en Belgique.": "Peppol-facturatie, 6 % btw, werfmarge, werkorganisatie: onze gidsen voor vakmensen en bouwondernemers in België.",
  "Essai 30 jours gratuit": "30 dagen gratis",
  "Essai gratuit": "Gratis proberen",
  "Assistant de devis": "Offerte-assistent",
  "Facturation": "Facturatie",
  "100 % belge": "100 % Belgisch",
  "À propos": "Over ons",
  "Guides & blog": "Gidsen & blog",
  "Guides & conseils de pros du bâtiment": "Gidsen & advies van bouwprofessionals",
  "Entretien de chaudière, prix d'une pompe à chaleur, aides et primes en Belgique : nos guides pratiques pour réussir vos travaux.": "Ketelonderhoud, prijs van een warmtepomp, steun en premies in België: onze praktische gidsen om uw werken tot een goed einde te brengen.",
  "Les premiers guides arrivent très bientôt.": "De eerste gidsen komen heel binnenkort.",
  "Lire": "Lees",
  "Tous les guides": "Alle gidsen",
  "Article introuvable": "Artikel niet gevonden",
  "Cet article n'existe pas ou n'est plus publié.": "Dit artikel bestaat niet of is niet meer gepubliceerd.",
  "Un projet de travaux ?": "Een bouwproject?",
  "Décrivez votre besoin gratuitement : un professionnel vérifié de votre région vous recontacte.": "Beschrijf uw behoefte gratis: een geverifieerde vakman uit uw regio neemt contact met u op.",
  "Publié le": "Gepubliceerd op",
  "Par l'équipe Devisto": "Door het Devisto-team",

  // ---- TradePage chrome ----
  "Page introuvable": "Pagina niet gevonden",
  "Publier mon projet gratuitement": "Publiceer mijn project gratis",
  "Les services des professionnels Devisto": "De diensten van de Devisto-vakmensen",
  "Questions fréquentes": "Veelgestelde vragen",
  "Prêt à lancer votre projet ?": "Klaar om uw project te starten?",
  "Décrivez votre besoin en quelques minutes : les professionnels qualifiés de votre région vous répondent directement.": "Beschrijf uw behoefte in enkele minuten: de gekwalificeerde vakmensen uit uw regio antwoorden u rechtstreeks.",

  // ---- Suivi / Carte / Déblocage ----
  "Lien de suivi invalide": "Ongeldige volglink",
  "Ce lien ne correspond à aucune demande.": "Deze link komt met geen enkele aanvraag overeen.",
  "Suivi de votre demande": "Opvolging van uw aanvraag",
  "Publiée": "Gepubliceerd",
  "Votre demande est en ligne": "Uw aanvraag staat online",
  "Prise en charge": "In behandeling",
  "Un professionnel vous a contacté ou va le faire": "Een vakman heeft u gecontacteerd of zal dit doen",
  "Une proposition vous a été transmise": "Er is u een voorstel bezorgd",
  "Mission confirmée": "Opdracht bevestigd",
  "Vous avez choisi votre professionnel": "U heeft uw vakman gekozen",
  "Publiée le": "Gepubliceerd op",
  "Une question sur votre demande ? Écrivez-nous à": "Een vraag over uw aanvraag? Schrijf ons op",
  "Carte Devisto": "Devisto-kaart",
  "Aujourd'hui": "Vandaag",
  "Rayon": "Straal",
  "Positions approximatives par zone : la localisation exacte des professionnels n'est jamais exposée publiquement.": "Geschatte posities per zone: de exacte locatie van de vakmensen wordt nooit publiek gedeeld.",
  "Coordonnées masquées": "Verborgen gegevens",
  "Coordonnées du client débloquées": "Klantgegevens ontgrendeld",
  "Contactez le client rapidement : les demandes urgentes partent vite.": "Contacteer de klant snel: dringende aanvragen gaan snel weg.",
  "Paiement sécurisé par Stripe · TVA gérée automatiquement": "Veilige betaling via Stripe · BTW automatisch beheerd",
  "Vérification du paiement en cours…": "Betaling wordt gecontroleerd…",
  "Demande introuvable.": "Aanvraag niet gevonden.",
  "Email :": "E-mail:",
  "Téléphone :": "Telefoon:",

  "Le paiement n'a pas abouti. Vous pouvez réessayer ci-dessous.": "De betaling is niet gelukt. U kunt hieronder opnieuw proberen.",
  "Débloquez les coordonnées complètes du client (nom, email, téléphone)": "Ontgrendel de volledige gegevens van de klant (naam, e-mail, telefoon)",
  "pour le contacter directement. Encore": "om rechtstreeks contact op te nemen. Nog",
  "disponible sur cette demande (3 maximum).": "beschikbaar op deze aanvraag (maximaal 3).",
  "disponibles sur cette demande (3 maximum).": "beschikbaar op deze aanvraag (maximaal 3).",
  "place": "plaats",
  "places": "plaatsen",
  "Redirection vers le paiement…": "Doorverwijzing naar de betaling…",
  "Débloquer pour 15 €": "Ontgrendel voor € 15",
  "Cette demande a déjà été débloquée par 3 professionnels.": "Deze aanvraag is al ontgrendeld door 3 vakmensen.",
  "Paiement impossible. Réessayez.": "Betaling onmogelijk. Probeer opnieuw.",
  "Mon espace pro": "Mijn pro-ruimte",

  // ---- Espaces membres ----
  "Espace professionnel": "Professionele ruimte",
  "Espace client": "Klantenruimte",
  "Demandes pour moi": "Aanvragen voor mij",
  "Missions B2B": "B2B-opdrachten",
  "Carte": "Kaart",
  "Disponibilités": "Beschikbaarheid",
  "Mes finances": "Mijn financiën",
  "Mon profil": "Mijn profiel",
  "Mes demandes": "Mijn aanvragen",
  "Mes missions": "Mijn opdrachten",
  "Candidatures": "Kandidaturen",
  "Nouvelle demande": "Nieuwe aanvraag",
  "Nouvelle mission": "Nieuwe opdracht",
  "Votre compte est bien enregistré. Le réseau de professionnels partenaires Devisto ouvrira prochainement — vous serez alerté par email dès que les demandes correspondant à vos métiers et votre zone seront disponibles.": "Uw account is goed geregistreerd. Het Devisto-partnernetwerk opent binnenkort — u wordt per e-mail verwittigd zodra aanvragen die bij uw vakgebieden en zone passen beschikbaar zijn.",
  "Aucune demande pour le moment": "Momenteel geen aanvragen",
  "Dès qu'un particulier publie un projet correspondant à vos métiers et votre zone, il apparaît ici et vous recevez une alerte email.": "Zodra een particulier een project publiceert dat bij uw vakgebieden en zone past, verschijnt het hier en ontvangt u een e-mailmelding.",
  "Nouvelle": "Nieuw",
  "Contactée": "Gecontacteerd",
  "Gagnée": "Gewonnen",
  "restante": "resterend",
  "restantes": "resterend",
  "Déjà débloquée par 3 professionnels": "Al ontgrendeld door 3 vakmensen",
  "Les missions B2B seront disponibles à l'ouverture du réseau de partenaires.": "De B2B-opdrachten zullen beschikbaar zijn bij de opening van het partnernetwerk.",
  "Toutes": "Alle",
  "Urgences": "Dringend",
  "Aucune mission disponible": "Geen opdracht beschikbaar",
  "Les missions de sous-traitance publiées par les entreprises et correspondant à vos qualifications apparaîtront ici.": "De onderaannemingsopdrachten van bedrijven die bij uw kwalificaties passen, verschijnen hier.",
  "Mission pourvue.": "Opdracht ingevuld.",
  "Candidature acceptée": "Kandidatuur aanvaard",
  "Candidature non retenue": "Kandidatuur niet weerhouden",
  "Question envoyée": "Vraag verzonden",
  "Candidature envoyée": "Kandidatuur verzonden",
  "Ouvrir l'espace mission": "Open de opdrachtruimte",
  "Accepter le tarif": "Aanvaard het tarief",
  "Contre-proposer": "Tegenvoorstel doen",
  "Poser une question": "Stel een vraag",
  "Envoyer la contre-proposition": "Verstuur het tegenvoorstel",
  "Envoyer la question": "Verstuur de vraag",
  "Contre-proposition envoyée": "Tegenvoorstel verzonden",
  "Candidature envoyée à l'entreprise.": "Kandidatuur verzonden naar het bedrijf.",
  "Candidature impossible.": "Kandidatuur onmogelijk.",
  "Statut en ce moment": "Status op dit moment",
  "Disponible maintenant": "Nu beschikbaar",
  "Disponible plus tard": "Later beschikbaar",
  "Indisponible": "Niet beschikbaar",
  "Disponible": "Beschikbaar",
  "Partiel": "Gedeeltelijk",
  "Vous ne recevrez pas d'alertes de nouvelles missions tant que vous êtes indisponible.": "U ontvangt geen meldingen van nieuwe opdrachten zolang u niet beschikbaar bent.",
  "Votre semaine type : le matching ne vous proposera que des missions compatibles avec vos jours disponibles.": "Uw typische week: de matching stelt u alleen opdrachten voor die compatibel zijn met uw beschikbare dagen.",
  "Enregistrer mes disponibilités": "Sla mijn beschikbaarheid op",
  "Disponibilités enregistrées.": "Beschikbaarheid opgeslagen.",
  "Statut mis à jour.": "Status bijgewerkt.",
  "Solde disponible": "Beschikbaar saldo",
  "Paiements en attente": "Betalingen in afwachting",
  "Revenus du mois": "Inkomsten deze maand",
  "Commissions Devisto": "Devisto-commissies",
  "Historique des paiements": "Betalingsgeschiedenis",
  "Aucun paiement pour le moment.": "Momenteel geen betalingen.",
  "Payé": "Betaald",
  "En attente": "In afwachting",
  "Description de votre activité": "Beschrijving van uw activiteit",
  "Spécialités": "Specialiteiten",
  "Années d'expérience": "Aantal jaren ervaring",
  "Tarif indicatif (€/jour)": "Richtlijn tarief (€/dag)",
  "Qualifications & certifications": "Kwalificaties & certificeringen",
  "Enregistrer les modifications": "Wijzigingen opslaan",
  "Profil mis à jour.": "Profiel bijgewerkt.",
  "Enregistrement impossible.": "Opslaan onmogelijk.",
  "Enregistrement impossible. Réessayez.": "Opslaan onmogelijk. Probeer opnieuw.",
  "Mise à jour impossible.": "Bijwerken onmogelijk.",
  "Mise à jour impossible. Réessayez.": "Bijwerken onmogelijk. Probeer opnieuw.",
  "Certification gaz": "Gascertificering",
  "Certification électrique": "Elektriciteitscertificering",
  "Qualification :": "Kwalificatie:",
  "Voici vos demandes publiées sur Devisto.": "Hier zijn uw aanvragen gepubliceerd op Devisto.",
  "Vous n'avez pas encore publié de demande.": "U heeft nog geen aanvraag gepubliceerd.",
  "Voici vos missions de sous-traitance publiées sur Devisto.": "Hier zijn uw onderaannemingsopdrachten gepubliceerd op Devisto.",
  "Vous n'avez pas encore publié de mission.": "U heeft nog geen opdracht gepubliceerd.",
  "Technicien sélectionné — la mission est pourvue.": "Technicus geselecteerd — de opdracht is ingevuld.",
  "Candidature refusée.": "Kandidatuur geweigerd.",
  "Action impossible.": "Actie onmogelijk.",
  "Bonjour": "Hallo",

  "Bonjour": "Hallo",
  "Lundi": "Maandag",
  "Mardi": "Dinsdag",
  "Mercredi": "Woensdag",
  "Jeudi": "Donderdag",
  "Vendredi": "Vrijdag",
  "Samedi": "Zaterdag",
  "Dimanche": "Zondag",
  "Contacté": "Gecontacteerd",
  "Mission gagnée": "Opdracht gewonnen",
  "jour": "dag",
  "commission": "commissie",
  "net": "netto",
  "Ex. : chaudières gaz, PAC": "Bv.: gasketels, warmtepompen",
  "Présentez votre entreprise et vos services…": "Presenteer uw bedrijf en uw diensten…",
  "Votre tarif €/jour": "Uw tarief €/dag",
  "Votre question à l'entreprise…": "Uw vraag aan het bedrijf…",
  "Frigoriste": "Koeltechnicus",
  "Autre certification": "Andere certificering",

  "Pourvue": "Ingevuld",
  "Ouvrir la mission": "Open de opdracht",
  "TVA vérifiée": "BTW geverifieerd",
  "Accepte le tarif proposé": "Aanvaardt het voorgestelde tarief",
  "Contre-proposition :": "Tegenvoorstel:",
  "Question posée": "Vraag gesteld",
  "Choisir ce technicien": "Kies deze technicus",
  "Refuser": "Weigeren",
  "Technicien sélectionné": "Technicus geselecteerd",
  "Refusée": "Geweigerd",
  "technicien": "technicus",
  "techniciens": "technici",

  // ---- Espace mission ----
  "Terminée — à valider": "Afgerond — te valideren",
  "Validée": "Gevalideerd",
  "En litige": "In geschil",
  "Cette mission n'existe pas ou vous n'y avez pas accès.": "Deze opdracht bestaat niet of u heeft er geen toegang toe.",
  "Messages": "Berichten",
  "Aucun message pour le moment.": "Momenteel geen berichten.",
  "Votre message…": "Uw bericht…",
  "Envoyer": "Verstuur",
  "Proposition de devis": "Offertevoorstel",
  "Rédiger un devis": "Schrijf een offerte",
  "Pré-remplir avec Devisto AI": "Vooraf invullen met Devisto AI",
  "Rédaction…": "Schrijven…",
  "Rédigez un devis ou pré-remplissez le rapport d'intervention en un clic.": "Schrijf een offerte of vul het interventieverslag met één klik vooraf in.",
  "Rapport de fin de mission": "Eindverslag van de opdracht",
  "Heures réalisées": "Gepresteerde uren",
  "Heures réalisées :": "Gepresteerde uren:",
  "Rapport / travaux effectués": "Verslag / uitgevoerde werken",
  "Commentaires / difficultés": "Opmerkingen / moeilijkheden",
  "Commentaires :": "Opmerkingen:",
  "Rapport :": "Verslag:",
  "Rapport envoyé à l'entreprise.": "Verslag verzonden naar het bedrijf.",
  "Validation de la mission": "Validatie van de opdracht",
  "Nombre de jours :": "Aantal dagen:",
  "Total mission :": "Totaal opdracht:",
  "Paiement de la mission": "Betaling van de opdracht",
  "Mission payée": "Opdracht betaald",
  "Évaluation": "Beoordeling",
  "Évaluer le professionnel": "Beoordeel de vakman",
  "Qualité du travail": "Kwaliteit van het werk",
  "Respect des délais": "Naleving van de termijnen",
  "Respect du prix": "Naleving van de prijs",
  "Note (facultatif — visible en cas de litige)…": "Score (optioneel — zichtbaar bij een geschil)…",
  "Votre évaluation alimente le Devisto Score du professionnel.": "Uw beoordeling voedt de Devisto-score van de vakman.",
  "Évaluation envoyée — merci ! Elle alimente le Devisto Score du professionnel.": "Beoordeling verzonden — bedankt! Ze voedt de Devisto-score van de vakman.",
  "Merci pour votre évaluation !": "Bedankt voor uw beoordeling!",
  "— première année offerte": "— eerste jaar gratis",
  "Devis copié.": "Offerte gekopieerd.",
  "Devis rédigé par Devisto AI — vérifiez avant envoi.": "Offerte geschreven door Devisto AI — controleer voor verzending.",
  "Message non envoyé.": "Bericht niet verzonden.",
  "Paiement confirmé.": "Betaling bevestigd.",
  "Paiement impossible.": "Betaling onmogelijk.",
  "Problème signalé — mission en litige.": "Probleem gemeld — opdracht in geschil.",
  "Rapport pré-rempli — complétez avec vos constats réels.": "Verslag vooraf ingevuld — vul aan met uw echte bevindingen.",
  "Évaluation impossible.": "Beoordeling onmogelijk.",
  "Envoi impossible.": "Verzenden onmogelijk.",
  "Décrivez les travaux réalisés…": "Beschrijf de uitgevoerde werken…",
  "Ex. : 16h sur 2 jours": "Bv.: 16u over 2 dagen",

  "Ex. : 16h sur 2 jours": "Bv.: 16u over 2 dagen",
  "Publiée": "Gepubliceerd",
  "Payée": "Betaald",
  "EN LITIGE": "IN GESCHIL",
  "Ponctualité": "Punctualiteit",
  "Communication": "Communicatie",
  "Envoyer le rapport": "Verstuur het verslag",
  "Envoyer l'évaluation": "Verstuur de beoordeling",
  "Commission Devisto": "Devisto-commissie",
  "Montant :": "Bedrag:",
  "Professionnel :": "Vakman:",
  " — première année offerte": " — eerste jaar gratis",

  // ---- Layout / admin ----
  "Navigation espace": "Ruimtenavigatie",
  "Demandes": "Aanvragen",
  "Partenaires": "Partners",
  "Missions": "Opdrachten",
  "Réglages": "Instellingen",
  "Tableau de bord": "Dashboard",
  "Commission plateforme (%)": "Platformcommissie (%)",
  "Pourcentage prélevé par Devisto sur chaque mission B2B payée. 0 % = première année offerte.": "Percentage dat Devisto inhoudt op elke betaalde B2B-opdracht. 0 % = eerste jaar gratis.",
  "Commission mise à jour.": "Commissie bijgewerkt.",
  "Valider (mission terminée)": "Valideren (opdracht afgerond)",
  "Signaler un problème": "Een probleem melden",
  "Aucun message pour le moment.": "Momenteel geen berichten.",
  "Aucune demande pour le moment.": "Momenteel geen aanvragen.",
  "Aucune mission pour le moment.": "Momenteel geen opdrachten.",
  "Aucun partenaire pour le moment.": "Momenteel geen partners.",

  " — première année offerte": " — eerste jaar gratis",
  "Commission prélevée sur chaque mission réalisée via la plateforme. Première année gratuite : la commission effective est de": "Commissie ingehouden op elke via het platform uitgevoerde opdracht. Eerste jaar gratis: de effectieve commissie bedraagt",
  "jusqu'au": "tot",
  "puis": "daarna",
  "TVA vérifiée VIES": "BTW geverifieerd via VIES",
  "TVA non vérifiée": "BTW niet geverifieerd",
  "Badge Devisto Verified attribué.": "Devisto Verified-badge toegekend.",
  "Badge retiré.": "Badge verwijderd.",
  "Pro :": "Vakman:",
  "Terminée": "Afgerond",
  "Blog": "Blog",

  "Pro :": "Vakman:",
  "Nouvel article": "Nieuw artikel",
  "Modifier l'article": "Artikel bewerken",
  "Retour à la liste": "Terug naar de lijst",
  "Rédaction assistée Devisto AI": "Schrijfassistentie Devisto AI",
  "Rédiger le brouillon": "Schrijf het ontwerp",
  "Brouillon généré — relisez et ajustez avant publication.": "Ontwerp gegenereerd — lees na en pas aan vóór publicatie.",
  "L'assistant n'a pas pu rédiger. Réessayez.": "De assistent kon niet schrijven. Probeer opnieuw.",
  "Titre": "Titel",
  "Slug (URL)": "Slug (URL)",
  "Catégorie": "Categorie",
  "Image de couverture (URL)": "Omslagafbeelding (URL)",
  "Résumé (SEO)": "Samenvatting (SEO)",
  "Contenu": "Inhoud",
  "(markdown léger : ## titre, - liste, **gras**)": "(lichte markdown: ## titel, - lijst, **vet**)",
  "Publier l'article (visible sur /blog)": "Publiceer het artikel (zichtbaar op /blog)",
  "Enregistrer l'article": "Artikel opslaan",
  "Article créé.": "Artikel aangemaakt.",
  "Article mis à jour.": "Artikel bijgewerkt.",
  "Article supprimé.": "Artikel verwijderd.",
  "Suppression impossible.": "Verwijderen onmogelijk.",
  "Chargement impossible.": "Laden onmogelijk.",
  "Aucun article pour le moment.": "Momenteel geen artikels.",
  "Publié": "Gepubliceerd",
  "Brouillon": "Ontwerp",
  "Modifier": "Bewerken",
  "Supprimer": "Verwijderen",
  "— figé pour préserver le référencement": "— vastgezet om de SEO te bewaren",
  "Auto si vide": "Automatisch indien leeg",

  "Auto si vide": "Automatisch indien leeg",

  // ---- Pages légales ----
  "Mentions légales": "Wettelijke vermeldingen",
  "Politique de confidentialité": "Privacybeleid",
  "Conditions générales": "Algemene voorwaarden",
  "Informations légales": "Wettelijke informatie",
  "Dernière mise à jour": "Laatste update",

  "Auto si vide": "Automatisch indien leeg",

  // ---- Provinces (valeurs FR conservées en base) ----
  "Bruxelles-Capitale": "Brussel-Hoofdstad",
  "Brabant wallon": "Waals-Brabant",
  "Hainaut": "Henegouwen",
  "Liège": "Luik",
  "Luxembourg": "Luxemburg",
  "Namur": "Namen",
  "Anvers": "Antwerpen",
  "Brabant flamand": "Vlaams-Brabant",
  "Flandre occidentale": "West-Vlaanderen",
  "Flandre orientale": "Oost-Vlaanderen",
  "Limbourg": "Limburg",

  // ---- 404 ----
  "Page introuvable": "Pagina niet gevonden",
  "Cette page n'existe pas ou a été déplacée.": "Deze pagina bestaat niet of is verplaatst.",

  // ---- Pipeline CRM ----
  "Nouvelles": "Nieuw",
  "À contacter": "Te contacteren",
  "Rendez-vous": "Afspraken",
  "Devis": "Offertes",
  "Missions": "Opdrachten",
  "professionnels réactifs": "actieve vakmensen",
  "Coordonnées débloquées": "Gegevens ontgrendeld",
  "Client contacté": "Klant gecontacteerd",
  "Rendez-vous planifié": "Afspraak gepland",
  "Mission perdue": "Opdracht verloren",
  "Travaux terminés": "Werken afgerond",
  "Mission non retenue": "Opdracht niet weerhouden",
  "Timeline": "Tijdlijn",
  "Aucun événement pour le moment.": "Momenteel geen gebeurtenissen.",
  "Demande publiée": "Aanvraag gepubliceerd",
  "Relance automatique envoyée": "Automatische herinnering verzonden",
  "Place libérée (pas de contact)": "Plaats vrijgegeven (geen contact)",
  "Avis client": "Klantbeoordeling",
  "Demande déjà prise en charge": "Aanvraag reeds in behandeling",
  "3 professionnels sont déjà en contact avec le client.": "3 vakmensen zijn al in contact met de klant.",
  "Voir les demandes disponibles": "Bekijk de beschikbare aanvragen",
  "places disponibles": "beschikbare plaatsen",
  "place disponible": "beschikbare plaats",
  "Déblocage : 15 €": "Ontgrendeling: € 15",
  "Score de profil : il évoluera avec votre activité réelle (réactivité, contacts, devis, missions gagnées, avis).": "Profielscore: deze evolueert met uw echte activiteit (reactiviteit, contacten, offertes, gewonnen opdrachten, beoordelingen).",
  "Réactivité (< 2 h)": "Reactiviteit (< 2 u)",
  "Taux de contact": "Contactpercentage",
  "Taux de devis": "Offertepercentage",
  "Missions gagnées": "Gewonnen opdrachten",
  "Satisfaction client": "Klanttevredenheid",
  "Demandes débloquées": "Ontgrendelde aanvragen",
  "Demande reçue": "Aanvraag ontvangen",
  "Professionnels sélectionnés": "Geselecteerde vakmensen",
  "professionnel(s) vont vous contacter": "vakman(nen) nemen contact met u op",
  "En attente de contact": "Wachten op contact",
  "Professionnel choisi": "Gekozen vakman",
  "En attente de votre choix": "Wachten op uw keuze",
  "Intervention / travaux": "Interventie / werken",
  "Votre avis": "Uw beoordeling",
  "Les professionnels sur votre demande": "De vakmensen op uw aanvraag",
  "J'ai été contacté": "Ik ben gecontacteerd",
  "Je choisis ce professionnel": "Ik kies deze vakman",
  "Donner mon avis": "Geef mijn beoordeling",
  "Avis envoyé": "Beoordeling verzonden",
  "Votre commentaire (facultatif)…": "Uw opmerking (optioneel)…",
  "Envoyer mon avis": "Verstuur mijn beoordeling",
  "Historique": "Geschiedenis",
  "Merci ! Votre retour a bien été enregistré.": "Bedankt! Uw feedback is goed geregistreerd.",
  "Pilotage des demandes": "Beheer van de aanvragen",
  "Qualité des demandes, réactivité des professionnels et taux de transformation des leads en missions.": "Kwaliteit van de aanvragen, reactiviteit van de vakmensen en conversie van leads naar opdrachten.",
  "Demandes publiées": "Gepubliceerde aanvragen",
  "Déblocages": "Ontgrendelingen",
  "Taux de conversion": "Conversiepercentage",
  "Note moyenne": "Gemiddelde score",
  "Relances et libération des places": "Herinneringen en vrijgave van plaatsen",
  "Si un professionnel débloque une demande sans contacter le client : relance automatique, puis libération de la place pour un autre professionnel.": "Als een vakman een aanvraag ontgrendelt zonder de klant te contacteren: automatische herinnering, daarna vrijgave van de plaats voor een andere vakman.",
  "Relance après (minutes)": "Herinnering na (minuten)",
  "Libération après (heures)": "Vrijgave na (uren)",
  "Paramètres enregistrés.": "Instellingen opgeslagen.",

  // ---- Statuts globaux ----
  "Active": "Actief",
  "Saturée — 3/3 professionnels": "Verzadigd — 3/3 vakmensen",
  "Contact en cours": "Contact lopende",
  "En attente client": "Wachten op klant",
  "Travaux en cours": "Werken lopende",
  "Demande annulée": "Aanvraag geannuleerd",

  // ---- Devisto Property ----
  "Devisto Property": "Devisto Property",
  "Créer un compte gestionnaire": "Maak een beheerdersaccount",
  "Gérez vos immeubles, vos lots et vos interventions depuis un seul espace dédié aux gestionnaires immobiliers et syndics.": "Beheer uw gebouwen, lots en interventies vanuit één ruimte voor vastgoedbeheerders en syndici.",
  "Société de gestion": "Beheermaatschappij",
  "Nom de votre société": "Naam van uw vennootschap",
  "Créer mon espace Property": "Maak mijn Property-ruimte",
  "Mon portefeuille": "Mijn portefeuille",
  "Immeubles": "Gebouwen",
  "Immeuble": "Gebouw",
  "Lots": "Lots",
  "Urgences": "Dringende gevallen",
  "Demandes actives": "Actieve aanvragen",
  "Interventions terminées": "Afgeronde interventies",
  "Total demandes": "Totaal aanvragen",
  "Mes immeubles": "Mijn gebouwen",
  "Ajoutez votre premier immeuble pour commencer.": "Voeg uw eerste gebouw toe om te beginnen.",
  "lots": "lots",
  "équipements": "apparatuur",
  "demandes": "aanvragen",
  "Ajouter un immeuble": "Voeg een gebouw toe",
  "Nom de l'immeuble": "Naam van het gebouw",
  "Immeuble ajouté.": "Gebouw toegevoegd.",
  "Immeuble supprimé.": "Gebouw verwijderd.",
  "Supprimer cet immeuble et ses lots/équipements ?": "Dit gebouw en zijn lots/apparatuur verwijderen?",
  "Ouvrir la fiche": "Open de fiche",
  "Tous les immeubles": "Alle gebouwen",
  "Lot / appartement": "Lot / appartement",
  "Parties communes": "Gemeenschappelijke delen",
  "Local technique": "Technische ruimte",
  "Ex. : Appartement 3B": "Bv.: Appartement 3B",
  "Ajouter": "Toevoegen",
  "Lot ajouté.": "Lot toegevoegd.",
  "Aucun lot pour le moment.": "Momenteel geen lots.",
  "Équipements": "Apparatuur",
  "Aucun équipement enregistré.": "Geen apparatuur geregistreerd.",
  "Équipement ajouté.": "Apparaat toegevoegd.",
  "Ex. : Chaudière gaz": "Bv.: Gasketel",
  "Marque (facultatif)": "Merk (optioneel)",
  "Historique des demandes": "Geschiedenis van de aanvragen",
  "Aucune demande pour cet immeuble.": "Geen aanvragen voor dit gebouw.",
  "Lot": "Lot",
  "Tout l'immeuble": "Hele gebouw",
  "Titre de la demande": "Titel van de aanvraag",
  "Décrivez le problème ou les travaux…": "Beschrijf het probleem of de werken…",
  "Demande publiée — les professionnels qualifiés sont alertés.": "Aanvraag gepubliceerd — de gekwalificeerde vakmensen zijn verwittigd.",
  "Aucune demande publiée.": "Geen aanvragen gepubliceerd.",
  "Ajoutez d'abord un immeuble.": "Voeg eerst een gebouw toe.",
  "Suivre cette demande": "Volg deze aanvraag",
  "Publication…": "Publiceren…",
  "Publier la demande": "Publiceer de aanvraag",
  "Gestionnaires & syndics": "Vastgoedbeheerders & syndici",
  "Gérez vos immeubles, interventions et professionnels depuis Devisto Property.": "Beheer uw gebouwen, interventies en vakmensen vanuit Devisto Property.",
  "Ouvrir Devisto Property": "Open Devisto Property",

  // ---- Commun ----
  "Chargement…": "Laden…",
  "Retour à l'accueil": "Terug naar de startpagina",
  "Retour à mon espace": "Terug naar mijn ruimte",
  "Continuer": "Doorgaan",
  "Retour": "Terug",
  "Enregistrer": "Opslaan",
  "Enregistrement…": "Opslaan…",
  "Une erreur est survenue. Réessayez.": "Er is een fout opgetreden. Probeer opnieuw.",
  "Gratuit et sans engagement": "Gratis en vrijblijvend",

  // ---- Section plateforme (accueil) ----
  "Une seule plateforme": "Eén enkel platform",
  "Tout Devisto, en une plateforme.": "Heel Devisto, in één platform.",
  "De la demande au suivi, Devisto digitalise chaque étape de vos projets techniques.": "Van aanvraag tot opvolging: Devisto digitaliseert elke stap van uw technische projecten.",
  "Suivi en temps réel": "Realtime opvolging",
  "Suivez l'avancement de votre demande étape par étape, sans créer de compte, grâce à votre lien de suivi personnel.": "Volg de vooruitgang van uw aanvraag stap voor stap, zonder account, via uw persoonlijke opvolgingslink.",
  "Décrivez votre problème en mots simples : notre assistant structure votre projet et le transmet aux bons spécialistes.": "Beschrijf uw probleem in eenvoudige woorden: onze assistent structureert uw project en bezorgt het aan de juiste specialisten.",
  "Maximum 3 professionnels": "Maximum 3 vakmensen",
  "Votre demande n'est jamais vendue en masse : trois professionnels vérifiés maximum vous contactent, avec un vrai suivi.": "Uw aanvraag wordt nooit massaal verkocht: maximum drie geverifieerde vakmensen contacteren u, met echte opvolging.",
  "Chaque professionnel est évalué sur sa réactivité, ses qualifications et ses résultats réels sur la plateforme.": "Elke vakman wordt beoordeeld op zijn reactiesnelheid, kwalificaties en reële resultaten op het platform.",
  "Guides & conseils": "Gidsen & advies",
  "Prix, primes, entretien : nos guides pratiques rédigés par des experts vous aident à décider.": "Prijzen, premies, onderhoud: onze praktische gidsen van experts helpen u beslissen.",
  "Découvrir nos guides": "Ontdek onze gidsen",
  "Français & Nederlands": "Frans & Nederlands",
  "Toute la plateforme, les emails et le suivi sont disponibles en français et en néerlandais.": "Het hele platform, de e-mails en de opvolging zijn beschikbaar in het Frans en het Nederlands.",

  // ---- Section Devisto Property (accueil) ----
  "Le tableau de bord technique de vos immeubles.": "Het technische dashboard van uw gebouwen.",
  "Centralisez immeubles, lots, équipements et interventions dans un seul espace, et créez des demandes liées à chaque unité en quelques clics.": "Centraliseer gebouwen, loten, apparatuur en interventies in één ruimte, en maak in enkele klikken aanvragen gekoppeld aan elke eenheid.",
  "Immeubles, lots et équipements au même endroit": "Gebouwen, loten en apparatuur op één plek",
  "Demandes liées à un lot ou un équipement précis": "Aanvragen gekoppeld aan een specifiek lot of toestel",
  "Suivi de chaque intervention, de la demande à la clôture": "Opvolging van elke interventie, van aanvraag tot afsluiting",
  "Historique technique centralisé de votre patrimoine": "Gecentraliseerde technische historiek van uw patrimonium",
  "Découvrir Devisto Property": "Ontdek Devisto Property",
  "Mes immeubles": "Mijn gebouwen",
  "lots": "loten",
  "équipements": "toestellen",
  "Immeubles": "Gebouwen",
  "Demandes actives": "Actieve aanvragen",

  // ---- Section pro enrichie (accueil) ----
  "Suivez chaque opportunité dans votre pipeline : contactée, devis envoyé, mission gagnée": "Volg elke opportuniteit in uw pipeline: gecontacteerd, offerte verzonden, opdracht gewonnen",
  "Valorisez votre Devisto Score : réactivité, qualifications et avis clients": "Versterk uw Devisto Score: reactiesnelheid, kwalificaties en klantbeoordelingen",
  "Candidatez aux missions B2B des entreprises": "Kandideer voor B2B-opdrachten van bedrijven",

  // ---- Blog teaser (accueil) ----
  "Guides & conseils de pros.": "Gidsen & advies van vakmensen.",
  "Nos derniers guides pour réussir vos projets techniques.": "Onze nieuwste gidsen om uw technische projecten te laten slagen.",

  // ---- Footer ----
  "Devisto Property (gestionnaires & syndics)": "Devisto Property (vastgoedbeheerders & syndici)",

  // ---- Admin blog bilingue ----
  "Langue de l'article": "Taal van het artikel",
  "Version liée (autre langue)": "Gekoppelde versie (andere taal)",
  "Aucune (article indépendant)": "Geen (onafhankelijk artikel)",

  // ---- Refonte header / hero (thème bleu) ----
  "Fonctionnalités": "Functionaliteiten",
  "Pour qui ?": "Voor wie?",
  "Tarifs": "Tarieven",
  "Se connecter": "Aanmelden",
  "Créer un compte": "Account aanmaken",
  "La plateforme qui": "Het platform dat",
  "connecte": "verbindt",
  "et simplifie les techniques spéciales du bâtiment.": "en de speciale bouwtechnieken vereenvoudigt.",
  "Particuliers, professionnels, syndics et gestionnaires immobiliers réunis dans un même écosystème.": "Particulieren, vakmensen, syndici en vastgoedbeheerders verenigd in één ecosysteem.",
  "Je suis un particulier": "Ik ben een particulier",
  "Je suis un professionnel": "Ik ben een vakman",
  "Devis rapides & transparents": "Snelle & transparante offertes",
  "Intervention en cours": "Lopende interventie",
  "Entretien chaudière": "Ketelonderhoud",
  "Aujourd'hui 09:00": "Vandaag 09:00",
  "Professionnel assigné": "Toegewezen vakman",
  "Technicien en route": "Technieker onderweg",
  "Arrivée estimée 09:15": "Geschatte aankomst 09:15",

  // ---- Fonctionnalités clés ----
  "Tout Devisto, en quelques fonctionnalités clés.": "Heel Devisto, in enkele kernfunctionaliteiten.",
  "Demandes qualifiées": "Gekwalificeerde aanvragen",
  "Des demandes claires et précises pour des devis pertinents.": "Duidelijke en precieze aanvragen voor relevante offertes.",
  "Professionnels vérifiés": "Geverifieerde vakmensen",
  "Un réseau de professionnels qualifiés et évalués.": "Een netwerk van gekwalificeerde en beoordeelde vakmensen.",
  "Suivez l'avancement de vos interventions en direct.": "Volg de voortgang van uw interventies live.",
  "Historique centralisé": "Gecentraliseerde historiek",
  "Tous vos documents et rapports accessibles en un seul endroit.": "Al uw documenten en rapporten toegankelijk op één plek.",
  "Gestion des bâtiments": "Gebouwenbeheer",
  "Centralisez et gérez tout votre parc immobilier.": "Centraliseer en beheer uw hele vastgoedpatrimonium.",

  // ---- Pour qui ? ----
  "Devisto met en relation particuliers, professionnels, syndics et gestionnaires avec des spécialistes qualifiés des techniques du bâtiment, partout en Belgique.": "Devisto verbindt particulieren, vakmensen, syndici en beheerders met gekwalificeerde specialisten in gebouwtechnieken, overal in België.",
  "Trouvez rapidement un professionnel de confiance et suivez votre intervention en toute transparence.": "Vind snel een betrouwbare vakman en volg uw interventie in alle transparantie.",
  "Recevez des demandes qualifiées et développez votre activité simplement.": "Ontvang gekwalificeerde aanvragen en ontwikkel uw activiteit eenvoudig.",
  "Syndics": "Syndici",
  "Gérez les interventions et le suivi technique de vos immeubles efficacement.": "Beheer de interventies en de technische opvolging van uw gebouwen efficiënt.",
  "Gestionnaires immobiliers": "Vastgoedbeheerders",
  "Pilotez votre parc immobilier et vos interventions en un clic.": "Beheer uw vastgoedpark en interventies met één klik.",

  // ---- Valeurs + CTA ----
  "Confiance": "Vertrouwen",
  "Des professionnels vérifiés et évalués par la communauté.": "Geverifieerde vakmensen, beoordeeld door de gemeenschap.",
  "Transparence": "Transparantie",
  "Des prix clairs, des devis détaillés et un suivi en temps réel.": "Duidelijke prijzen, gedetailleerde offertes en realtime opvolging.",
  "Efficacité": "Efficiëntie",
  "Gagnez du temps grâce à une organisation simplifiée.": "Bespaar tijd dankzij een vereenvoudigde organisatie.",
  "Innovation": "Innovatie",
  "La technologie au service d'un secteur essentiel.": "Technologie ten dienste van een essentiële sector.",
  "Prêt à simplifier vos interventions ?": "Klaar om uw interventies te vereenvoudigen?",
  "Rejoignez Devisto dès aujourd'hui.": "Sluit u vandaag nog aan bij Devisto.",

  // ---- Page Tarifs ----
  "Des tarifs simples et transparents.": "Eenvoudige en transparante tarieven.",
  "Gratuit pour les particuliers. Une offre de lancement exceptionnelle pour les professionnels. Sans engagement.": "Gratis voor particulieren. Een uitzonderlijk lanceringsaanbod voor vakmensen. Vrijblijvend.",
  "Pour tous vos projets et dépannages, sans frais.": "Voor al uw projecten en herstellingen, zonder kosten.",
  "Publiez vos demandes gratuitement": "Plaats uw aanvragen gratis",
  "Maximum 3 professionnels vérifiés par demande": "Maximum 3 geverifieerde vakmensen per aanvraag",
  "Suivi en temps réel de votre intervention": "Realtime opvolging van uw interventie",
  "Assistant Devisto AI inclus": "Devisto AI-assistent inbegrepen",
  "pendant 6 mois, puis 49 €/mois": "gedurende 6 maanden, daarna € 49/maand",
  "Offre de lancement": "Lanceringsaanbod",
  "Tout l'outil de gestion de votre activité technique.": "Het volledige beheertool voor uw technische activiteit.",
  "Demandes qualifiées selon vos métiers et votre zone": "Gekwalificeerde aanvragen volgens uw vakgebieden en zone",
  "Pipeline complet : contact, devis, mission gagnée": "Volledige pipeline: contact, offerte, gewonnen opdracht",
  "Missions B2B des entreprises": "B2B-opdrachten van bedrijven",
  "Devisto Score et avis clients valorisés": "Devisto Score en klantbeoordelingen in de waagschaal",
  "Assistant Devisto AI pour vos devis et rapports": "Devisto AI-assistent voor uw offertes en rapporten",
  "Sans engagement, résiliable à tout moment": "Vrijblijvend, altijd opzegbaar",
  "Entreprises & Gestionnaires": "Bedrijven & beheerders",
  "Sur devis": "Op offerte",
  "Pour les donneurs d'ordre, syndics et gestionnaires de parc.": "Voor opdrachtgevers, syndici en parkbeheerders.",
  "Missions B2B et sous-traitance qualifiée": "B2B-opdrachten en gekwalificeerde onderaanneming",
  "Gestion multi-bâtiments et historique technique": "Multi-gebouwenbeheer en technische historiek",
  "Demandes liées à vos lots et équipements": "Aanvragen gekoppeld aan uw loten en apparatuur",
  "Accompagnement et support dédiés": "Begeleiding en toegewijde support",
  "Nous contacter": "Contacteer ons",
  "Le déblocage des coordonnées (15 € par demande) reste gratuit jusqu'à l'ouverture du réseau de partenaires. La commission sur les missions B2B est de 0 % la première année.": "Het deblokkeren van contactgegevens (€ 15 per aanvraag) blijft gratis tot de opening van het partnernetwerk. De commissie op B2B-opdrachten bedraagt 0 % het eerste jaar.",

  // ---- Assistant Devisto (chat) ----
  "Assistant Devisto": "Devisto-assistent",
  "En ligne": "Online",
  "Fermer": "Sluiten",
  "Envoyer": "Verzenden",
  "Ouvrir le chat": "Chat openen",
  "Posez votre question…": "Stel uw vraag…",
  "Bonjour, je suis l'assistant Devisto. Comment puis-je vous aider ?": "Hallo, ik ben de Devisto-assistent. Hoe kan ik u helpen?",
  "L'assistant n'a pas pu répondre. Réessayez.": "De assistent kon niet antwoorden. Probeer opnieuw.",
  "Comment gérer mes demandes ?": "Hoe beheer ik mijn aanvragen?",
  "Comment envoyer un devis ?": "Hoe verstuur ik een offerte?",
  "Comment fonctionne le Devisto Score ?": "Hoe werkt de Devisto Score?",
  "Comment ajouter un immeuble ?": "Hoe voeg ik een gebouw toe?",
  "Comment créer une demande pour un lot ?": "Hoe maak ik een aanvraag voor een lot?",
  "Comment suivre une intervention ?": "Hoe volg ik een interventie?",
  "Comment publier une mission ?": "Hoe publiceer ik een opdracht?",
  "Comment choisir un technicien ?": "Hoe kies ik een technieker?",
  "Comment se passe le paiement ?": "Hoe verloopt de betaling?",
  "Comment décrire mon projet ?": "Hoe beschrijf ik mijn project?",
  "Comment suivre ma demande ?": "Hoe volg ik mijn aanvraag?",
  "Comment devenir partenaire pro ?": "Hoe word ik pro-partner?",

  // ---- Footer modernisé ----
  "La plateforme qui connecte et simplifie les techniques spéciales du bâtiment.": "Het platform dat de speciale bouwtechnieken verbindt en vereenvoudigt.",
  "Chauffage, plomberie, sanitaire, électricité, ventilation, climatisation et pompes à chaleur. Particuliers, professionnels, syndics et gestionnaires immobiliers réunis dans un même écosystème.": "Verwarming, loodgieterij, sanitair, elektriciteit, ventilatie, airconditioning en warmtepompen. Particulieren, vakmensen, syndici en vastgoedbeheerders verenigd in één ecosysteem.",
  "Entreprise": "Bedrijf",
  "À propos de Devisto": "Over Devisto",
  "Carrières": "Vacatures",
  "Besoin d'aide ?": "Hulp nodig?",
  "Notre équipe est à votre écoute du lundi au vendredi de 8h à 18h.": "Ons team staat voor u klaar van maandag tot vrijdag, van 8u tot 18u.",
  "Ou envoyez-nous un message": "Of stuur ons een bericht",
  "Envoyer un message": "Stuur een bericht",
  "Des experts qualifiés et évalués par la communauté.": "Gekwalificeerde experts, beoordeeld door de gemeenschap.",
  "Comparez rapidement et sans engagement.": "Vergelijk snel en vrijblijvend.",
  "Suivez votre intervention en direct jusqu'à la fin.": "Volg uw interventie live tot het einde.",
  "Données sécurisées": "Beveiligde gegevens",
  "Vos informations sont protégées et confidentielles.": "Uw gegevens zijn beschermd en vertrouwelijk.",
  "Liens légaux": "Juridische links",
  "Gestion des cookies": "Cookiebeheer",

  // ---- Bannière métiers + texte mission ----
  "Une nouvelle façon de gérer les interventions techniques": "Een nieuwe manier om technische interventies te beheren",
  "Devisto a été pensé pour répondre aux difficultés rencontrées quotidiennement dans le secteur : demandes mal orientées, manque de visibilité, échanges dispersés et suivi insuffisant.": "Devisto werd ontwikkeld als antwoord op de dagelijkse moeilijkheden in de sector: verkeerd georiënteerde aanvragen, gebrek aan zichtbaarheid, versnipperde uitwisselingen en onvoldoende opvolging.",
  "Notre objectif est simple :": "Ons doel is eenvoudig:",
  "connecter les bonnes compétences au bon moment": "de juiste competenties op het juiste moment verbinden",
  "et rendre chaque intervention plus transparente, plus réactive et mieux suivie.": "en elke interventie transparanter, reactiever en beter opgevolgd maken.",
  "De la demande initiale jusqu'à la fin de l'intervention, Devisto centralise les informations essentielles pour faciliter la communication entre clients, professionnels, gestionnaires immobiliers et syndics.": "Van de eerste aanvraag tot het einde van de interventie centraliseert Devisto de essentiële informatie om de communicatie tussen klanten, vakmensen, vastgoedbeheerders en syndici te vergemakkelijken.",

  // ---- Devisto Live (suivi technicien) ----
  "Suivi en temps réel pour le client": "Realtime opvolging voor de klant",
  "Démarrez votre trajet : le client verra votre position et votre heure d'arrivée estimée sur sa page de suivi.": "Start uw rit: de klant ziet uw positie en geschatte aankomsttijd op zijn opvolgingspagina.",
  "Temps de trajet estimé (minutes)": "Geschatte reistijd (minuten)",
  "min de trajet": "min rijden",
  "Démarrer le trajet": "Start de rit",
  "En route": "Onderweg",
  "Arrivé sur place": "Ter plaatse aangekomen",
  "Intervention en cours": "Interventie bezig",
  "Intervention terminée": "Interventie afgerond",
  "Arrivée estimée": "Geschatte aankomst",
  "Position partagée en direct": "Positie live gedeeld",
  "Position non partagée (activez la géolocalisation)": "Positie niet gedeeld (activeer geolocatie)",
  "Je suis arrivé": "Ik ben aangekomen",
  "Démarrer l'intervention": "Start de interventie",
  "Terminer l'intervention": "Interventie afronden",
  "Le client a été informé de la fin de l'intervention.": "De klant werd ingelicht over het einde van de interventie.",
  "Technicien en route": "Technieker onderweg",
  "Technicien arrivé": "Technieker aangekomen",
  "Position du technicien mise à jour": "Positie van de technieker bijgewerkt om",

  // ---- Pipeline enrichi + réactivité ----
  "Intervention": "Interventie",
  "Le plus réactif": "De meest reactieve",
  "a réagi en": "reageerde binnen",

  // ---- Documents immeubles ----
  "Documents": "Documenten",
  "Contrats, rapports d'intervention, factures et garanties liés à cet immeuble.": "Contracten, interventierapporten, facturen en garanties gekoppeld aan dit gebouw.",
  "Aucun document pour le moment.": "Nog geen documenten.",
  "Nom du document (ex. : Contrat maintenance)": "Naam van het document (bv. Onderhoudscontract)",
  "Contrat": "Contract",
  "Rapport": "Rapport",
  "Facture": "Factuur",
  "Garantie": "Garantie",
  "Autre": "Andere",
  "Choisir un fichier": "Kies een bestand",
  "Document ajouté.": "Document toegevoegd.",
  "Document supprimé.": "Document verwijderd.",
  "Envoi impossible. Réessayez.": "Upload mislukt. Probeer opnieuw.",
  "Téléchargement impossible. Réessayez.": "Download mislukt. Probeer opnieuw.",
  "Ouvrir": "Openen",
  "Vidéo de présentation": "Presentatievideo",
  "Photo": "Foto",
  "Photos": "Foto's",
  "Photos du problème": "Foto's van het probleem",
  "Photos avant / après": "Foto's voor / na",
  "Photo ajoutée.": "Foto toegevoegd.",
  "Photos ajoutées.": "Foto's toegevoegd.",
  "Supprimer la photo": "Foto verwijderen",
  "Envoi de la photo impossible. Réessayez.": "Foto uploaden mislukt. Probeer opnieuw.",
  "JPG, PNG ou photo iPhone (HEIC) — compressées automatiquement avant l'envoi.": "JPG, PNG of iPhone-foto (HEIC) — automatisch gecomprimeerd voor het uploaden.",
  "PDF, Word, JPG, PNG ou photo iPhone (HEIC) — 25 Mo max, images compressées automatiquement.": "PDF, Word, JPG, PNG of iPhone-foto (HEIC) — max. 25 MB, afbeeldingen automatisch gecomprimeerd.",
  "Fiche technique": "Technische fiche",
  "Historique technique": "Technische historiek",
  "Passeport technique": "Technisch paspoort",
  "Passeport mis à jour.": "Paspoort bijgewerkt.",
  "Enregistrer le passeport": "Paspoort opslaan",
  "Passeport introuvable": "Paspoort niet gevonden",
  "Ce QR code n'est plus valide.": "Deze QR-code is niet meer geldig.",
  "Passeport technique généré par Devisto": "Technisch paspoort gegenereerd door Devisto",
  "Retour à l'immeuble": "Terug naar het gebouw",
  "N° de série": "Serienummer",
  "Emplacement": "Locatie",
  "Ex. : Local technique -1": "Bv. : Technische ruimte -1",
  "Date d'installation": "Installatiedatum",
  "Garantie jusqu'au": "Garantie tot",
  "Fréquence d'entretien": "Onderhoudsfrequentie",
  "Pas de rappel": "Geen herinnering",
  "Tous les 6 mois": "Elke 6 maanden",
  "Tous les 12 mois": "Elke 12 maanden",
  "Tous les 2 ans": "Elke 2 jaar",
  "Notes techniques (facultatif)": "Technische notities (optioneel)",
  "Installé le": "Geïnstalleerd op",
  "Dernier entretien": "Laatste onderhoud",
  "Prochain entretien": "Volgend onderhoud",
  "entretien": "onderhoud",
  "Entretien": "Onderhoud",
  "Réparation": "Herstelling",
  "Contrôle réglementaire": "Wettelijke controle",
  "Remplacement": "Vervanging",
  "Mise en service": "Indienststelling",
  "Réalisé par": "Uitgevoerd door",
  "Constats / pièces": "Vaststellingen / onderdelen",
  "Intervention enregistrée.": "Interventie opgeslagen.",
  "Aucune intervention enregistrée.": "Nog geen interventies.",
  "Équipement introuvable.": "Uitrusting niet gevonden.",
  "Documents de l'équipement": "Documenten van de uitrusting",
  "Facture d'achat, garantie, notices et rapports d'entretien de cet équipement.": "Aankoopfactuur, garantie, handleidingen en onderhoudsrapporten van deze uitrusting.",
  "À coller sur l'équipement": "Op de uitrusting te kleven",
  "Copier le lien": "Link kopiëren",
  "Lien copié.": "Link gekopieerd.",
  "Plan d'entretien": "Onderhoudsplan",
  "Rappels automatiques 30 jours avant chaque échéance.": "Automatische herinneringen 30 dagen voor elke vervaldatum.",
  "Envoyer les rappels": "Herinneringen versturen",
  "rappel(s) envoyé(s) par email.": "herinnering(en) per e-mail verzonden.",
  "Aucun rappel à envoyer pour le moment.": "Momenteel geen herinneringen te versturen.",
  "Envoi des rappels impossible.": "Herinneringen versturen mislukt.",
  "Ajoutez une date d'installation à vos équipements pour planifier les entretiens.": "Voeg een installatiedatum toe aan uw uitrusting om onderhoud te plannen.",
  "Notifications": "Meldingen",
  "Aucune notification.": "Geen meldingen.",
  "Tout marquer comme lu": "Alles als gelezen markeren",
  "Facturation": "Facturatie",
  "Facturation électronique structurée": "Gestructureerde e-facturatie",
  "Chaque facture est générée au format Peppol BIS Billing 3.0 (UBL 2.1), obligatoire en Belgique entre assujettis. Téléchargez le XML pour l'envoyer via votre access point Peppol ou votre comptable.": "Elke factuur wordt gegenereerd in Peppol BIS Billing 3.0-formaat (UBL 2.1), verplicht in België tussen btw-plichtigen. Download de XML om ze via uw Peppol access point of boekhouder te versturen.",
  "Nouvelle facture": "Nieuwe factuur",
  "Créer la facture": "Factuur aanmaken",
  "Facture créée.": "Factuur aangemaakt.",
  "Création impossible.": "Aanmaken mislukt.",
  "Factures émises": "Uitgaande facturen",
  "Factures reçues": "Ontvangen facturen",
  "Aucune facture émise.": "Nog geen uitgaande facturen.",
  "Nom du client": "Naam van de klant",
  "TVA client (BE 0123.456.789)": "Btw klant (BE 0123.456.789)",
  "Email du client": "E-mail van de klant",
  "Référence / note (facultatif)": "Referentie / nota (optioneel)",
  "Prestation (ex. : entretien chaudière)": "Prestatie (bv. : onderhoud ketel)",
  "Ajouter une ligne": "Lijn toevoegen",
  "Paiement comptant": "Contante betaling",
  "jours": "dagen",
  "échéance": "vervaldag",
  "HTVA": "Excl. btw",
  "TVA": "Btw",
  "Total": "Totaal",
  "XML Peppol": "Peppol-XML",
  "Envoyer": "Versturen",
  "Marquer payée": "Als betaald markeren",
  "Facture envoyée au client.": "Factuur naar de klant verstuurd.",
  "Facture marquée payée.": "Factuur als betaald gemarkeerd.",
  "Brouillon": "Ontwerp",
  "Envoyée": "Verstuurd",
  "Payée": "Betaald",
  "Annulée": "Geannuleerd",
  "Statistiques": "Statistieken",
  "Nouvelles demandes": "Nieuwe aanvragen",
  "À contacter": "Te contacteren",
  "Rendez-vous": "Afspraken",
  "Devis envoyés": "Verzonden bestekken",
  "Revenus": "Inkomsten",
  "Interventions": "Interventies",
  "Interventions attribuées, en cours et terminées sur votre portefeuille.": "Toegewezen, lopende en afgeronde interventies in uw portefeuille.",
  "Aucune intervention en cours.": "Geen lopende interventie.",
  "Suivre en temps réel": "Live opvolgen",
};
